var _style, _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _polygon45, _polygon46, _polygon47, _polygon48, _polygon49, _polygon50, _polygon51, _polygon52, _polygon53, _polygon54, _polygon55, _polygon56, _polygon57, _polygon58, _polygon59, _polygon60, _polygon61, _polygon62, _polygon63, _polygon64, _polygon65, _polygon66, _polygon67, _polygon68, _polygon69, _polygon70, _polygon71, _polygon72, _polygon73, _polygon74, _polygon75, _polygon76, _polygon77, _polygon78, _polygon79, _polygon80, _polygon81, _polygon82, _polygon83, _polygon84, _polygon85, _polygon86, _polygon87, _polygon88, _polygon89, _polygon90, _polygon91, _polygon92, _polygon93, _polygon94, _polygon95, _polygon96, _polygon97, _polygon98, _polygon99, _polygon100, _polygon101, _polygon102, _polygon103, _polygon104, _polygon105, _polygon106, _polygon107, _polygon108, _polygon109, _polygon110, _polygon111, _polygon112, _polygon113, _polygon114, _polygon115, _polygon116, _polygon117, _polygon118, _polygon119, _polygon120, _polygon121, _polygon122, _polygon123, _polygon124, _polygon125, _polygon126, _polygon127, _polygon128, _polygon129, _polygon130, _polygon131, _polygon132, _polygon133, _polygon134, _polygon135, _polygon136, _polygon137, _polygon138, _polygon139, _polygon140, _polygon141, _polygon142, _polygon143, _polygon144, _polygon145, _polygon146, _polygon147, _polygon148, _polygon149, _polygon150, _polygon151, _polygon152, _polygon153, _polygon154, _polygon155, _polygon156, _polygon157, _polygon158, _polygon159, _polygon160, _polygon161, _polygon162, _polygon163, _polygon164, _polygon165, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpinableWhiteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 755.5",
    style: {
      enableBackground: "new 0 0 1000 755.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_4_);}\r\n\t.st1{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_5_);}\r\n\t.st2{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_6_);}\r\n\t.st3{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_7_);}\r\n\t.st4{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_8_);}\r\n\t.st5{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_9_);}\r\n\t.st6{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_10_);}\r\n\t.st7{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_11_);}\r\n\t.st8{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_12_);}\r\n\t.st9{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_13_);}\r\n\t.st10{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_14_);}\r\n\t.st11{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_15_);}\r\n\t.st12{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_16_);}\r\n\t.st13{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_17_);}\r\n\t.st14{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_18_);}\r\n\t.st15{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_19_);}\r\n\t.st16{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_20_);}\r\n\t.st17{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_21_);}\r\n\t.st18{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_22_);}\r\n\t.st19{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_23_);}\r\n\t.st20{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_24_);}\r\n\t.st21{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_25_);}\r\n\t.st22{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_26_);}\r\n\t.st23{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_27_);}\r\n\t.st24{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_28_);}\r\n\t.st25{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_29_);}\r\n\t.st26{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_30_);}\r\n\t.st27{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_31_);}\r\n\t.st28{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_32_);}\r\n\t.st29{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_33_);}\r\n\t.st30{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_34_);}\r\n\t.st31{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_35_);}\r\n\t.st32{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_36_);}\r\n\t.st33{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_37_);}\r\n\t.st34{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_38_);}\r\n\t.st35{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_39_);}\r\n\t.st36{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_40_);}\r\n\t.st37{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_41_);}\r\n\t.st38{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_42_);}\r\n\t.st39{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_43_);}\r\n\t.st40{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_44_);}\r\n\t.st41{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_45_);}\r\n\t.st42{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_46_);}\r\n\t.st43{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_47_);}\r\n\t.st44{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_48_);}\r\n\t.st45{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_49_);}\r\n\t.st46{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_50_);}\r\n\t.st47{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_51_);}\r\n\t.st48{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_52_);}\r\n\t.st49{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_53_);}\r\n\t.st50{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_54_);}\r\n\t.st51{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_55_);}\r\n\t.st52{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_56_);}\r\n\t.st53{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_57_);}\r\n\t.st54{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_58_);}\r\n\t.st55{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_59_);}\r\n\t.st56{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_60_);}\r\n\t.st57{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_61_);}\r\n\t.st58{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_62_);}\r\n\t.st59{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_63_);}\r\n\t.st60{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_64_);}\r\n\t.st61{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_65_);}\r\n\t.st62{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_66_);}\r\n\t.st63{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_67_);}\r\n\t.st64{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_68_);}\r\n\t.st65{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_69_);}\r\n\t.st66{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_70_);}\r\n\t.st67{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_71_);}\r\n\t.st68{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_72_);}\r\n\t.st69{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_73_);}\r\n\t.st70{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_74_);}\r\n\t.st71{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_75_);}\r\n\t.st72{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_76_);}\r\n\t.st73{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_77_);}\r\n\t.st74{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_78_);}\r\n\t.st75{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_79_);}\r\n\t.st76{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_80_);}\r\n\t.st77{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_81_);}\r\n\t.st78{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_82_);}\r\n\t.st79{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_83_);}\r\n\t.st80{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_84_);}\r\n\t.st81{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_85_);}\r\n\t.st82{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_86_);}\r\n\t.st83{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_87_);}\r\n\t.st84{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_88_);}\r\n\t.st85{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_89_);}\r\n\t.st86{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_90_);}\r\n\t.st87{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_91_);}\r\n\t.st88{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_92_);}\r\n\t.st89{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_93_);}\r\n\t.st90{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_94_);}\r\n\t.st91{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_95_);}\r\n\t.st92{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_96_);}\r\n\t.st93{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_97_);}\r\n\t.st94{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_98_);}\r\n\t.st95{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_99_);}\r\n\t.st96{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_100_);}\r\n\t.st97{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_101_);}\r\n\t.st98{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_102_);}\r\n\t.st99{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_103_);}\r\n\t.st100{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_104_);}\r\n\t.st101{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_105_);}\r\n\t.st102{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_106_);}\r\n\t.st103{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_107_);}\r\n\t.st104{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_108_);}\r\n\t.st105{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_109_);}\r\n\t.st106{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_110_);}\r\n\t.st107{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_111_);}\r\n\t.st108{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_112_);}\r\n\t.st109{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_113_);}\r\n\t.st110{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_114_);}\r\n\t.st111{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_115_);}\r\n\t.st112{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_116_);}\r\n\t.st113{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_117_);}\r\n\t.st114{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_118_);}\r\n\t.st115{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_119_);}\r\n\t.st116{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_120_);}\r\n\t.st117{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_121_);}\r\n\t.st118{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_122_);}\r\n\t.st119{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_123_);}\r\n\t.st120{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_124_);}\r\n\t.st121{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_125_);}\r\n\t.st122{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_126_);}\r\n\t.st123{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_127_);}\r\n\t.st124{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_128_);}\r\n\t.st125{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_129_);}\r\n\t.st126{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_130_);}\r\n\t.st127{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_131_);}\r\n\t.st128{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_132_);}\r\n\t.st129{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_133_);}\r\n\t.st130{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_134_);}\r\n\t.st131{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_135_);}\r\n\t.st132{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_136_);}\r\n\t.st133{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_137_);}\r\n\t.st134{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_138_);}\r\n\t.st135{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_139_);}\r\n\t.st136{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_140_);}\r\n\t.st137{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_141_);}\r\n\t.st138{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_142_);}\r\n\t.st139{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_143_);}\r\n\t.st140{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_144_);}\r\n\t.st141{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_145_);}\r\n\t.st142{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_146_);}\r\n\t.st143{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_147_);}\r\n\t.st144{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_148_);}\r\n\t.st145{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_149_);}\r\n\t.st146{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_150_);}\r\n\t.st147{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_151_);}\r\n\t.st148{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_152_);}\r\n\t.st149{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_153_);}\r\n\t.st150{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_154_);}\r\n\t.st151{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_155_);}\r\n\t.st152{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_156_);}\r\n\t.st153{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_157_);}\r\n\t.st154{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_158_);}\r\n\t.st155{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_159_);}\r\n\t.st156{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_160_);}\r\n\t.st157{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_161_);}\r\n\t.st158{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_162_);}\r\n\t.st159{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_163_);}\r\n\t.st160{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_164_);}\r\n\t.st161{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_165_);}\r\n\t.st162{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_166_);}\r\n\t.st163{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_167_);}\r\n\t.st164{clip-path:url(#SVGID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_168_);}\r\n\t.st165{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M500.8,256c10.5,0,19.1,8.5,19.1,19.1c0,10.5-8.5,19.1-19.1,19.1c-10.5,0-19.1-8.5-19.1-19.1 C481.8,264.6,490.3,256,500.8,256L500.8,256z M445.2,275.1c0,30.7,24.9,55.6,55.6,55.6c30.7,0,55.6-24.9,55.6-55.6 c0-30.7-24.9-55.6-55.6-55.6C470.1,219.5,445.2,244.4,445.2,275.1L445.2,275.1z M538.2,275.1c0-20.6-16.7-37.3-37.3-37.3 s-37.3,16.7-37.3,37.3c0,20.6,16.7,37.3,37.3,37.3S538.2,295.7,538.2,275.1L538.2,275.1z M319.1,68.6 c-12.5,16.6-21.5,35.5-26.8,56.6C338.9,60.4,414.9,18.3,500.8,18.3c104.3,0,194,62.2,234.3,151.4c-2.4-23.3-7.8-43.7-15.6-61.6 C669.2,42.4,590,0,500.8,0C431.2,0,367.6,25.9,319.1,68.6L319.1,68.6z M287.1,169.2c39-78.6,120.1-132.6,213.8-132.6 c95,0,177,55.5,215.3,135.8h-20.5C658.8,102.5,585.4,54.9,500.8,54.9c-98.3,0-181.5,64.3-209.8,153.2 C288.4,196,287.1,183.1,287.1,169.2L287.1,169.2L287.1,169.2z M302,239.8c4.3,8.6,9.4,16.6,15.6,24 c5.8-96.2,85.7-172.4,183.3-172.4c63.4,0,119.3,32.1,152.3,81h21.6c-35.2-59.4-99.9-99.3-173.9-99.3 C401.3,73.2,318.7,145.1,302,239.8L302,239.8z M335.6,282c-0.1-2.3-0.2-4.6-0.2-6.9c0-77.3,53.1-142.3,124.8-160.3 c-11.9,6.6-20.3,16-24,28.2c-48.9,23.9-82.5,74.1-82.5,132.2c0,7.1,0.5,14,1.5,20.8C348.1,291.6,341.6,286.9,335.6,282 L335.6,282z M376,307c-2.6-10.2-4-20.9-4-31.9c0-46.9,25-87.9,62.5-110.4c0.8,6.8,3,12.5,6.5,17.5 c-30.5,19.7-50.7,53.9-50.7,92.9c0,14.5,2.8,28.3,7.8,41C390.4,313.3,383,310.3,376,307L376,307z M422.4,323.7 c-8.8-14.1-13.8-30.7-13.8-48.5c0-34.3,18.8-64.3,46.6-80.2c6.4,3.8,14.1,7,23.2,9.7c-29.9,9.5-51.6,37.4-51.6,70.5 c0,22.2,9.8,42.1,25.3,55.7l-7.7-1.7C436.8,327.4,429.5,325.6,422.4,323.7L422.4,323.7z M521.2,346.2 c30.9-8.9,53.5-37.3,53.5-71.1c0-20.8-8.6-39.5-22.4-53l20,4.6c2.7,0.6,5.4,1.2,8.1,1.8c8,13.7,12.6,29.6,12.6,46.5 c0,32.7-17.1,61.5-42.7,77.8c-4.9-1.5-10.3-2.8-16.3-3.9L521.2,346.2L521.2,346.2z M570.1,361.2c25.1-20.3,41.2-51.3,41.2-86.1 c0-14.3-2.7-28-7.7-40.5c7.4,2.1,14.6,4.4,21.5,6.8c2.9,10.8,4.5,22.1,4.5,33.7c0,39.3-17.6,74.5-45.3,98.1 C581,368.9,576.4,364.8,570.1,361.2L570.1,361.2z M591.3,391.1c34.4-26.9,56.6-68.8,56.6-116c0-8.7-0.8-17.3-2.2-25.6 c6.9,3.1,13.5,6.3,19.8,9.9c0.5,5.2,0.8,10.5,0.8,15.8c0,60.4-32.3,113.2-80.6,142c4-6.3,6-13.6,6-21.8 C591.5,393.9,591.5,392.5,591.3,391.1L591.3,391.1z M468.3,437.3c-28.9-8.3-49.8-25.1-60.8-48.4c-8.1-6.6-15.4-14.1-21.9-22.3 h-22.6C387,402.5,424.5,428.5,468.3,437.3L468.3,437.3z M341.5,366.6h-20.8c33.4,65.5,101.5,110.5,180.1,110.5 c107.3,0,195-83.7,201.5-189.3c-5.4-5.8-11.4-11.1-17.9-16c0,1.1,0,2.3,0,3.4c0,101.4-82.2,183.7-183.7,183.7 C432.7,458.8,373.2,421.7,341.5,366.6L341.5,366.6z M300.4,366.6c34.7,76,111.4,128.7,200.4,128.7c110,0,201.2-80.7,217.6-186.1 c5.2,9,9.4,18.8,12.3,29.5c-27.9,100.8-120.2,174.9-229.9,174.9c-99.3,0-184.4-60.7-220.3-147H300.4L300.4,366.6z M267.5,382.6 c4.5,28.2,13.6,52.8,26.4,73.8c50.4,57.5,124.4,93.8,206.9,93.8c96.1,0,180.7-49.3,229.9-123.9c3.6-13.9,5.5-28.8,5.5-44.5 c0-1.2,0-2.5,0-3.7C696.4,468.6,606,531.9,500.8,531.9C397.4,531.9,308.2,470.7,267.5,382.6L267.5,382.6z M581.4,130.7 c19,10.6,35.6,24.8,49.1,41.7h-24.3c-2.6-2.7-5.4-5.3-8.2-7.8C594.6,151.6,589.3,140.1,581.4,130.7z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 267.5264,
    y1: 275.1024,
    x2: 736.163,
    y2: 275.1024
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_2_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_3_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 541.712,
    y1: 104.9027,
    x2: 898.9626,
    y2: 104.9027
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "898.3,325.4 899,324.9 542.4,-115.6 541.7,-115.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 539.7661,
    y1: 105.1589,
    x2: 900.2768,
    y2: 105.1589
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "900.3,323.8 896.3,327 539.8,-113.5 543.7,-116.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 537.1376,
    y1: 107.2869,
    x2: 897.6484,
    y2: 107.2869
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "897.6,325.9 893.7,329.1 537.1,-111.4 541.1,-114.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 534.5092,
    y1: 109.414,
    x2: 895.0192,
    y2: 109.414
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "895,328.1 891.1,331.3 534.5,-109.2 538.5,-112.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 531.88,
    y1: 111.542,
    x2: 892.3909,
    y2: 111.542
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "892.4,330.2 888.4,333.4 531.9,-107.1 535.8,-110.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 529.2516,
    y1: 113.6712,
    x2: 889.7617,
    y2: 113.6712
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "889.8,332.3 885.8,335.5 529.3,-105 533.2,-108.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 526.6199,
    y1: 115.7996,
    x2: 887.1333,
    y2: 115.7996
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "887.1,334.4 883.2,337.6 526.6,-102.8 530.6,-106  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 523.9915,
    y1: 117.9276,
    x2: 884.5024,
    y2: 117.9276
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "884.5,336.6 880.6,339.8 524,-100.7 527.9,-103.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 521.3632,
    y1: 120.0551,
    x2: 881.8732,
    y2: 120.0551
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "881.9,338.7 877.9,341.9 521.4,-98.6 525.3,-101.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 518.734,
    y1: 122.1826,
    x2: 879.2448,
    y2: 122.1826
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "879.2,340.8 875.3,344 518.7,-96.5 522.7,-99.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 516.1056,
    y1: 124.3132,
    x2: 876.6156,
    y2: 124.3132
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "876.6,343 872.7,346.2 516.1,-94.3 520,-97.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 513.4764,
    y1: 126.4403,
    x2: 873.9872,
    y2: 126.4403
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "874,345.1 870,348.3 513.5,-92.2 517.4,-95.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 510.8454,
    y1: 128.5682,
    x2: 871.3588,
    y2: 128.5682
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "871.4,347.2 867.4,350.4 510.8,-90.1 514.8,-93.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 508.2171,
    y1: 130.6962,
    x2: 868.7297,
    y2: 130.6962
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "868.7,349.3 864.8,352.5 508.2,-88 512.2,-91.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 505.5879,
    y1: 132.8233,
    x2: 866.0987,
    y2: 132.8233
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "866.1,351.5 862.2,354.7 505.6,-85.8 509.5,-89  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 502.9595,
    y1: 134.9538,
    x2: 863.4695,
    y2: 134.9538
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "863.5,353.6 859.5,356.8 503,-83.7 506.9,-86.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 500.3303,
    y1: 137.081,
    x2: 860.8411,
    y2: 137.081
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "860.8,355.7 856.9,358.9 500.3,-81.6 504.3,-84.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 497.702,
    y1: 139.2089,
    x2: 858.2128,
    y2: 139.2089
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "858.2,357.9 854.3,361.1 497.7,-79.4 501.6,-82.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 495.0727,
    y1: 141.3369,
    x2: 855.5836,
    y2: 141.3369
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "855.6,360 851.6,363.2 495.1,-77.3 499,-80.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 492.4418,
    y1: 143.4666,
    x2: 852.9552,
    y2: 143.4666
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "853,362.1 849,365.3 492.4,-75.2 496.4,-78.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 489.8134,
    y1: 145.5945,
    x2: 850.3234,
    y2: 145.5945
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "850.3,364.2 846.4,367.4 489.8,-73.1 493.8,-76.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 487.1842,
    y1: 147.7221,
    x2: 847.6951,
    y2: 147.7221
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "847.7,366.4 843.8,369.6 487.2,-70.9 491.1,-74.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 484.5558,
    y1: 149.8496,
    x2: 845.0667,
    y2: 149.8496
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "845.1,368.5 841.1,371.7 484.6,-68.8 488.5,-72  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 481.9275,
    y1: 151.9776,
    x2: 842.4376,
    y2: 151.9776
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "842.4,370.6 838.5,373.8 481.9,-66.7 485.9,-69.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 479.2982,
    y1: 154.1073,
    x2: 839.8091,
    y2: 154.1073
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "839.8,372.8 835.9,375.9 479.3,-64.5 483.2,-67.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 476.6673,
    y1: 156.2352,
    x2: 837.1799,
    y2: 156.2352
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "837.2,374.9 833.2,378.1 476.7,-62.4 480.6,-65.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 474.0381,
    y1: 158.3632,
    x2: 834.5515,
    y2: 158.3632
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "834.6,377 830.6,380.2 474,-60.3 478,-63.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 471.4098,
    y1: 160.4903,
    x2: 831.9206,
    y2: 160.4903
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "831.9,379.1 828,382.3 471.4,-58.2 475.4,-61.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 468.7814,
    y1: 162.6182,
    x2: 829.2914,
    y2: 162.6182
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "829.3,381.3 825.3,384.5 468.8,-56 472.7,-59.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 466.1522,
    y1: 164.7479,
    x2: 826.663,
    y2: 164.7479
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "826.7,383.4 822.7,386.6 466.2,-53.9 470.1,-57.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 463.5238,
    y1: 166.8759,
    x2: 824.0338,
    y2: 166.8759
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "824,385.5 820.1,388.7 463.5,-51.8 467.5,-55  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 460.8946,
    y1: 169.0039,
    x2: 821.4055,
    y2: 169.0039
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "821.4,387.7 817.5,390.8 460.9,-49.6 464.8,-52.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 458.2637,
    y1: 171.131,
    x2: 818.7762,
    y2: 171.131
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "818.8,389.8 814.8,393 458.3,-47.5 462.2,-50.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 455.6353,
    y1: 173.2615,
    x2: 816.1454,
    y2: 173.2615
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "816.1,391.9 812.2,395.1 455.6,-45.4 459.6,-48.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 453.0061,
    y1: 175.389,
    x2: 813.517,
    y2: 175.389
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "st34",
    points: "813.5,394 809.6,397.2 453,-43.3 456.9,-46.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 450.3778,
    y1: 177.5166,
    x2: 810.8878,
    y2: 177.5166
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "810.9,396.2 806.9,399.4 450.4,-41.1 454.3,-44.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 447.7485,
    y1: 179.6445,
    x2: 808.2594,
    y2: 179.6445
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "808.3,398.3 804.3,401.5 447.7,-39 451.7,-42.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 445.1201,
    y1: 181.772,
    x2: 805.631,
    y2: 181.772
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "805.6,400.4 801.7,403.6 445.1,-36.9 449.1,-40.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 442.4892,
    y1: 183.9021,
    x2: 803.0018,
    y2: 183.9021
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "803,402.6 799.1,405.7 442.5,-34.7 446.4,-37.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 439.86,
    y1: 186.0302,
    x2: 800.3735,
    y2: 186.0302
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "800.4,404.7 796.4,407.9 439.9,-32.6 443.8,-35.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 437.2317,
    y1: 188.1573,
    x2: 797.7416,
    y2: 188.1573
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "797.7,406.8 793.8,410 437.2,-30.5 441.2,-33.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 434.6024,
    y1: 190.2852,
    x2: 795.1133,
    y2: 190.2852
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "795.1,408.9 791.2,412.1 434.6,-28.4 438.5,-31.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 431.9741,
    y1: 192.4136,
    x2: 792.4849,
    y2: 192.4136
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "st42",
    points: "792.5,411.1 788.5,414.3 432,-26.2 435.9,-29.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 429.3458,
    y1: 194.5429,
    x2: 789.8557,
    y2: 194.5429
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "st43",
    points: "789.9,413.2 785.9,416.4 429.3,-24.1 433.3,-27.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 426.7165,
    y1: 196.6708,
    x2: 787.2274,
    y2: 196.6708
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "st44",
    points: "787.2,415.3 783.3,418.5 426.7,-22 430.7,-25.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 424.0856,
    y1: 198.7979,
    x2: 784.5981,
    y2: 198.7979
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "784.6,417.4 780.7,420.6 424.1,-19.9 428,-23  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 421.4564,
    y1: 200.9259,
    x2: 781.9698,
    y2: 200.9259
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "782,419.6 778,422.8 421.5,-17.7 425.4,-20.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 418.828,
    y1: 203.056,
    x2: 779.3389,
    y2: 203.056
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "779.3,421.7 775.4,424.9 418.8,-15.6 422.8,-18.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 416.1996,
    y1: 205.1835,
    x2: 776.7097,
    y2: 205.1835
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "776.7,423.8 772.8,427 416.2,-13.5 420.1,-16.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 413.5704,
    y1: 207.3115,
    x2: 774.0814,
    y2: 207.3115
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "774.1,426 770.1,429.2 413.6,-11.3 417.5,-14.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 410.942,
    y1: 209.439,
    x2: 771.4521,
    y2: 209.439
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    className: "st50",
    points: "771.5,428.1 767.5,431.3 410.9,-9.2 414.9,-12.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 408.3128,
    y1: 211.5666,
    x2: 768.8237,
    y2: 211.5666
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    className: "st51",
    points: "768.8,430.2 764.9,433.4 408.3,-7.1 412.3,-10.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 405.6819,
    y1: 213.6971,
    x2: 766.1945,
    y2: 213.6971
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    className: "st52",
    points: "766.2,432.3 762.2,435.5 405.7,-5 409.6,-8.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 403.0536,
    y1: 215.8242,
    x2: 763.5635,
    y2: 215.8242
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    className: "st53",
    points: "763.6,434.5 759.6,437.7 403.1,-2.8 407,-6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 400.4243,
    y1: 217.9521,
    x2: 760.9352,
    y2: 217.9521
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    className: "st54",
    points: "760.9,436.6 757,439.8 400.4,-0.7 404.4,-3.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: 397.796,
    y1: 220.0797,
    x2: 758.306,
    y2: 220.0797
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    className: "st55",
    points: "758.3,438.7 754.4,441.9 397.8,1.4 401.7,-1.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: 395.1667,
    y1: 222.2086,
    x2: 755.6776,
    y2: 222.2086
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    className: "st56",
    points: "755.7,440.9 751.7,444 395.2,3.6 399.1,0.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: 392.5384,
    y1: 224.3378,
    x2: 753.0493,
    y2: 224.3378
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    className: "st57",
    points: "753,443 749.1,446.2 392.5,5.7 396.5,2.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientUnits: "userSpaceOnUse",
    x1: 389.9075,
    y1: 226.4649,
    x2: 750.42,
    y2: 226.4649
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon59 || (_polygon59 = /*#__PURE__*/React.createElement("polygon", {
    className: "st58",
    points: "750.4,445.1 746.5,448.3 389.9,7.8 393.9,4.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: 387.2783,
    y1: 228.5929,
    x2: 747.7917,
    y2: 228.5929
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon60 || (_polygon60 = /*#__PURE__*/React.createElement("polygon", {
    className: "st59",
    points: "747.8,447.2 743.8,450.4 387.3,9.9 391.2,6.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: 384.6499,
    y1: 230.7208,
    x2: 745.1599,
    y2: 230.7208
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon61 || (_polygon61 = /*#__PURE__*/React.createElement("polygon", {
    className: "st60",
    points: "745.2,449.4 741.2,452.6 384.6,12.1 388.6,8.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_65_",
    gradientUnits: "userSpaceOnUse",
    x1: 382.0207,
    y1: 232.8505,
    x2: 742.5316,
    y2: 232.8505
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon62 || (_polygon62 = /*#__PURE__*/React.createElement("polygon", {
    className: "st61",
    points: "742.5,451.5 738.6,454.7 382,14.2 386,11  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_66_",
    gradientUnits: "userSpaceOnUse",
    x1: 379.3923,
    y1: 234.9785,
    x2: 739.9032,
    y2: 234.9785
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon63 || (_polygon63 = /*#__PURE__*/React.createElement("polygon", {
    className: "st62",
    points: "739.9,453.6 736,456.8 379.4,16.3 383.3,13.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_67_",
    gradientUnits: "userSpaceOnUse",
    x1: 376.7639,
    y1: 237.106,
    x2: 737.274,
    y2: 237.106
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon64 || (_polygon64 = /*#__PURE__*/React.createElement("polygon", {
    className: "st63",
    points: "737.3,455.8 733.3,458.9 376.8,18.5 380.7,15.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_68_",
    gradientUnits: "userSpaceOnUse",
    x1: 374.1347,
    y1: 239.2336,
    x2: 734.6456,
    y2: 239.2336
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon65 || (_polygon65 = /*#__PURE__*/React.createElement("polygon", {
    className: "st64",
    points: "734.6,457.9 730.7,461.1 374.1,20.6 378.1,17.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_69_",
    gradientUnits: "userSpaceOnUse",
    x1: 371.5038,
    y1: 241.3615,
    x2: 732.0164,
    y2: 241.3615
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon66 || (_polygon66 = /*#__PURE__*/React.createElement("polygon", {
    className: "st65",
    points: "732,460 728.1,463.2 371.5,22.7 375.4,19.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_70_",
    gradientUnits: "userSpaceOnUse",
    x1: 368.8746,
    y1: 243.4912,
    x2: 729.3854,
    y2: 243.4912
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon67 || (_polygon67 = /*#__PURE__*/React.createElement("polygon", {
    className: "st66",
    points: "729.4,462.1 725.4,465.3 368.9,24.8 372.8,21.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_71_",
    gradientUnits: "userSpaceOnUse",
    x1: 366.2462,
    y1: 245.6191,
    x2: 726.7571,
    y2: 245.6191
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon68 || (_polygon68 = /*#__PURE__*/React.createElement("polygon", {
    className: "st67",
    points: "726.8,464.3 722.8,467.5 366.2,27 370.2,23.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_72_",
    gradientUnits: "userSpaceOnUse",
    x1: 363.6179,
    y1: 247.7467,
    x2: 724.1279,
    y2: 247.7467
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon69 || (_polygon69 = /*#__PURE__*/React.createElement("polygon", {
    className: "st68",
    points: "724.1,466.4 720.2,469.6 363.6,29.1 367.6,25.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_73_",
    gradientUnits: "userSpaceOnUse",
    x1: 360.9887,
    y1: 249.8742,
    x2: 721.4995,
    y2: 249.8742
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon70 || (_polygon70 = /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "721.5,468.5 717.6,471.7 361,31.2 364.9,28  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_74_",
    gradientUnits: "userSpaceOnUse",
    x1: 358.3603,
    y1: 252.0048,
    x2: 718.8703,
    y2: 252.0048
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon71 || (_polygon71 = /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "718.9,470.7 714.9,473.8 358.4,33.4 362.3,30.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_75_",
    gradientUnits: "userSpaceOnUse",
    x1: 355.7285,
    y1: 254.1319,
    x2: 716.2419,
    y2: 254.1319
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon72 || (_polygon72 = /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "716.2,472.8 712.3,476 355.7,35.5 359.7,32.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_76_",
    gradientUnits: "userSpaceOnUse",
    x1: 353.1002,
    y1: 256.2599,
    x2: 713.6127,
    y2: 256.2599
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon73 || (_polygon73 = /*#__PURE__*/React.createElement("polygon", {
    className: "st72",
    points: "713.6,474.9 709.7,478.1 353.1,37.6 357,34.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_77_",
    gradientUnits: "userSpaceOnUse",
    x1: 350.4718,
    y1: 258.3878,
    x2: 710.9818,
    y2: 258.3878
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon74 || (_polygon74 = /*#__PURE__*/React.createElement("polygon", {
    className: "st73",
    points: "711,477 707,480.2 350.5,39.7 354.4,36.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_78_",
    gradientUnits: "userSpaceOnUse",
    x1: 347.8426,
    y1: 260.5149,
    x2: 708.3535,
    y2: 260.5149
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon75 || (_polygon75 = /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "708.4,479.2 704.4,482.4 347.8,41.9 351.8,38.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_79_",
    gradientUnits: "userSpaceOnUse",
    x1: 345.2142,
    y1: 262.6454,
    x2: 705.7242,
    y2: 262.6454
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon76 || (_polygon76 = /*#__PURE__*/React.createElement("polygon", {
    className: "st75",
    points: "705.7,481.3 701.8,484.5 345.2,44 349.2,40.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_80_",
    gradientUnits: "userSpaceOnUse",
    x1: 342.585,
    y1: 264.7729,
    x2: 703.0959,
    y2: 264.7729
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon77 || (_polygon77 = /*#__PURE__*/React.createElement("polygon", {
    className: "st76",
    points: "703.1,483.4 699.2,486.6 342.6,46.1 346.5,42.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_81_",
    gradientUnits: "userSpaceOnUse",
    x1: 339.9566,
    y1: 266.9005,
    x2: 700.4675,
    y2: 266.9005
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon78 || (_polygon78 = /*#__PURE__*/React.createElement("polygon", {
    className: "st77",
    points: "700.5,485.5 696.5,488.7 340,48.3 343.9,45.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_82_",
    gradientUnits: "userSpaceOnUse",
    x1: 337.3257,
    y1: 269.0285,
    x2: 697.8383,
    y2: 269.0285
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon79 || (_polygon79 = /*#__PURE__*/React.createElement("polygon", {
    className: "st78",
    points: "697.8,487.7 693.9,490.9 337.3,50.4 341.3,47.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_83_",
    gradientUnits: "userSpaceOnUse",
    x1: 334.6965,
    y1: 271.1569,
    x2: 695.2073,
    y2: 271.1569
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon80 || (_polygon80 = /*#__PURE__*/React.createElement("polygon", {
    className: "st79",
    points: "695.2,489.8 691.3,493 334.7,52.5 338.6,49.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_84_",
    gradientUnits: "userSpaceOnUse",
    x1: 332.0681,
    y1: 273.2861,
    x2: 692.5781,
    y2: 273.2861
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon81 || (_polygon81 = /*#__PURE__*/React.createElement("polygon", {
    className: "st80",
    points: "692.6,491.9 688.6,495.1 332.1,54.6 336,51.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_85_",
    gradientUnits: "userSpaceOnUse",
    x1: 329.4389,
    y1: 275.4137,
    x2: 689.9498,
    y2: 275.4137
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon82 || (_polygon82 = /*#__PURE__*/React.createElement("polygon", {
    className: "st81",
    points: "689.9,494.1 686,497.3 329.4,56.8 333.4,53.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_86_",
    gradientUnits: "userSpaceOnUse",
    x1: 326.8106,
    y1: 277.5412,
    x2: 687.3214,
    y2: 277.5412
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon83 || (_polygon83 = /*#__PURE__*/React.createElement("polygon", {
    className: "st82",
    points: "687.3,496.2 683.4,499.4 326.8,58.9 330.8,55.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_87_",
    gradientUnits: "userSpaceOnUse",
    x1: 324.1822,
    y1: 279.6691,
    x2: 684.6922,
    y2: 279.6691
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon84 || (_polygon84 = /*#__PURE__*/React.createElement("polygon", {
    className: "st83",
    points: "684.7,498.3 680.7,501.5 324.2,61 328.1,57.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_88_",
    gradientUnits: "userSpaceOnUse",
    x1: 321.5504,
    y1: 281.7989,
    x2: 682.0638,
    y2: 281.7989
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon85 || (_polygon85 = /*#__PURE__*/React.createElement("polygon", {
    className: "st84",
    points: "682.1,500.4 678.1,503.6 321.6,63.1 325.5,60  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_89_",
    gradientUnits: "userSpaceOnUse",
    x1: 318.9221,
    y1: 283.9268,
    x2: 679.4346,
    y2: 283.9268
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon86 || (_polygon86 = /*#__PURE__*/React.createElement("polygon", {
    className: "st85",
    points: "679.4,502.6 675.5,505.8 318.9,65.3 322.9,62.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_90_",
    gradientUnits: "userSpaceOnUse",
    x1: 316.2928,
    y1: 286.0548,
    x2: 676.8037,
    y2: 286.0548
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon87 || (_polygon87 = /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "676.8,504.7 672.9,507.9 316.3,67.4 320.2,64.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_91_",
    gradientUnits: "userSpaceOnUse",
    x1: 313.6645,
    y1: 288.1819,
    x2: 674.1754,
    y2: 288.1819
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon88 || (_polygon88 = /*#__PURE__*/React.createElement("polygon", {
    className: "st87",
    points: "674.2,506.8 670.2,510 313.7,69.5 317.6,66.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_92_",
    gradientUnits: "userSpaceOnUse",
    x1: 311.0361,
    y1: 290.3098,
    x2: 671.5461,
    y2: 290.3098
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon89 || (_polygon89 = /*#__PURE__*/React.createElement("polygon", {
    className: "st88",
    points: "671.5,509 667.6,512.2 311,71.7 315,68.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_93_",
    gradientUnits: "userSpaceOnUse",
    x1: 308.4069,
    y1: 292.4399,
    x2: 668.9178,
    y2: 292.4399
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon90 || (_polygon90 = /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "668.9,511.1 665,514.3 308.4,73.8 312.4,70.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_94_",
    gradientUnits: "userSpaceOnUse",
    x1: 305.7785,
    y1: 294.5675,
    x2: 666.2886,
    y2: 294.5675
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon91 || (_polygon91 = /*#__PURE__*/React.createElement("polygon", {
    className: "st90",
    points: "666.3,513.2 662.3,516.4 305.8,75.9 309.7,72.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_95_",
    gradientUnits: "userSpaceOnUse",
    x1: 303.1468,
    y1: 296.6955,
    x2: 663.6602,
    y2: 296.6955
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon92 || (_polygon92 = /*#__PURE__*/React.createElement("polygon", {
    className: "st91",
    points: "663.7,515.3 659.7,518.5 303.1,78 307.1,74.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_96_",
    gradientUnits: "userSpaceOnUse",
    x1: 300.5184,
    y1: 298.8225,
    x2: 661.0292,
    y2: 298.8225
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon93 || (_polygon93 = /*#__PURE__*/React.createElement("polygon", {
    className: "st92",
    points: "661,517.5 657.1,520.7 300.5,80.2 304.5,77  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_97_",
    gradientUnits: "userSpaceOnUse",
    x1: 297.89,
    y1: 300.9518,
    x2: 658.4,
    y2: 300.9518
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon94 || (_polygon94 = /*#__PURE__*/React.createElement("polygon", {
    className: "st93",
    points: "658.4,519.6 654.5,522.8 297.9,82.3 301.8,79.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_98_",
    gradientUnits: "userSpaceOnUse",
    x1: 295.2608,
    y1: 303.0806,
    x2: 655.7717,
    y2: 303.0806
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon95 || (_polygon95 = /*#__PURE__*/React.createElement("polygon", {
    className: "st94",
    points: "655.8,521.7 651.8,524.9 295.3,84.4 299.2,81.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_99_",
    gradientUnits: "userSpaceOnUse",
    x1: 292.6325,
    y1: 305.2082,
    x2: 653.1425,
    y2: 305.2082
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon96 || (_polygon96 = /*#__PURE__*/React.createElement("polygon", {
    className: "st95",
    points: "653.1,523.9 649.2,527 292.6,86.6 296.6,83.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_100_",
    gradientUnits: "userSpaceOnUse",
    x1: 290.0033,
    y1: 307.3361,
    x2: 650.5141,
    y2: 307.3361
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon97 || (_polygon97 = /*#__PURE__*/React.createElement("polygon", {
    className: "st96",
    points: "650.5,526 646.6,529.2 290,88.7 293.9,85.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_101_",
    gradientUnits: "userSpaceOnUse",
    x1: 287.3723,
    y1: 309.4637,
    x2: 647.8857,
    y2: 309.4637
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon98 || (_polygon98 = /*#__PURE__*/React.createElement("polygon", {
    className: "st97",
    points: "647.9,528.1 643.9,531.3 287.4,90.8 291.3,87.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_102_",
    gradientUnits: "userSpaceOnUse",
    x1: 284.744,
    y1: 311.5938,
    x2: 645.2565,
    y2: 311.5938
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon99 || (_polygon99 = /*#__PURE__*/React.createElement("polygon", {
    className: "st98",
    points: "645.3,530.2 641.3,533.4 284.7,92.9 288.7,89.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_103_",
    gradientUnits: "userSpaceOnUse",
    x1: 282.1147,
    y1: 313.7217,
    x2: 642.6256,
    y2: 313.7217
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon100 || (_polygon100 = /*#__PURE__*/React.createElement("polygon", {
    className: "st99",
    points: "642.6,532.4 638.7,535.6 282.1,95.1 286.1,91.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_104_",
    gradientUnits: "userSpaceOnUse",
    x1: 279.4864,
    y1: 315.8488,
    x2: 639.9964,
    y2: 315.8488
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon101 || (_polygon101 = /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "640,534.5 636.1,537.7 279.5,97.2 283.4,94  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_105_",
    gradientUnits: "userSpaceOnUse",
    x1: 276.8572,
    y1: 317.9768,
    x2: 637.368,
    y2: 317.9768
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon102 || (_polygon102 = /*#__PURE__*/React.createElement("polygon", {
    className: "st101",
    points: "637.4,536.6 633.4,539.8 276.9,99.3 280.8,96.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_106_",
    gradientUnits: "userSpaceOnUse",
    x1: 274.2288,
    y1: 320.1048,
    x2: 634.7397,
    y2: 320.1048
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon103 || (_polygon103 = /*#__PURE__*/React.createElement("polygon", {
    className: "st102",
    points: "634.7,538.8 630.8,541.9 274.2,101.5 278.2,98.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_107_",
    gradientUnits: "userSpaceOnUse",
    x1: 271.6004,
    y1: 322.2345,
    x2: 632.1105,
    y2: 322.2345
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon104 || (_polygon104 = /*#__PURE__*/React.createElement("polygon", {
    className: "st103",
    points: "632.1,540.9 628.2,544.1 271.6,103.6 275.5,100.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_108_",
    gradientUnits: "userSpaceOnUse",
    x1: 268.9687,
    y1: 324.3624,
    x2: 629.4821,
    y2: 324.3624
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon105 || (_polygon105 = /*#__PURE__*/React.createElement("polygon", {
    className: "st104",
    points: "629.5,543 625.5,546.2 269,105.7 272.9,102.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_109_",
    gradientUnits: "userSpaceOnUse",
    x1: 266.3403,
    y1: 326.4895,
    x2: 626.8528,
    y2: 326.4895
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon106 || (_polygon106 = /*#__PURE__*/React.createElement("polygon", {
    className: "st105",
    points: "626.9,545.1 622.9,548.3 266.3,107.8 270.3,104.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_110_",
    gradientUnits: "userSpaceOnUse",
    x1: 263.7112,
    y1: 328.6175,
    x2: 624.2219,
    y2: 328.6175
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon107 || (_polygon107 = /*#__PURE__*/React.createElement("polygon", {
    className: "st106",
    points: "624.2,547.3 620.3,550.5 263.7,110 267.7,106.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_111_",
    gradientUnits: "userSpaceOnUse",
    x1: 261.0827,
    y1: 330.7476,
    x2: 621.5936,
    y2: 330.7476
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon108 || (_polygon108 = /*#__PURE__*/React.createElement("polygon", {
    className: "st107",
    points: "621.6,549.4 617.7,552.6 261.1,112.1 265,108.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_112_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.4544,
    y1: 332.8752,
    x2: 618.9644,
    y2: 332.8752
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon109 || (_polygon109 = /*#__PURE__*/React.createElement("polygon", {
    className: "st108",
    points: "619,551.5 615,554.7 258.5,114.2 262.4,111  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_113_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.8251,
    y1: 335.0031,
    x2: 616.336,
    y2: 335.0031
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon110 || (_polygon110 = /*#__PURE__*/React.createElement("polygon", {
    className: "st109",
    points: "616.3,553.7 612.4,556.8 255.8,116.4 259.8,113.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_114_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.1942,
    y1: 337.1306,
    x2: 613.7068,
    y2: 337.1306
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon111 || (_polygon111 = /*#__PURE__*/React.createElement("polygon", {
    className: "st110",
    points: "613.7,555.8 609.8,559 253.2,118.5 257.1,115.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_115_",
    gradientUnits: "userSpaceOnUse",
    x1: 250.565,
    y1: 339.2582,
    x2: 611.0784,
    y2: 339.2582
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon112 || (_polygon112 = /*#__PURE__*/React.createElement("polygon", {
    className: "st111",
    points: "611.1,557.9 607.1,561.1 250.6,120.6 254.5,117.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_116_",
    gradientUnits: "userSpaceOnUse",
    x1: 247.9366,
    y1: 341.3887,
    x2: 608.4475,
    y2: 341.3887
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon113 || (_polygon113 = /*#__PURE__*/React.createElement("polygon", {
    className: "st112",
    points: "608.4,560 604.5,563.2 247.9,122.7 251.9,119.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_117_",
    gradientUnits: "userSpaceOnUse",
    x1: 245.3083,
    y1: 343.5158,
    x2: 605.8183,
    y2: 343.5158
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon114 || (_polygon114 = /*#__PURE__*/React.createElement("polygon", {
    className: "st113",
    points: "605.8,562.2 601.9,565.4 245.3,124.9 249.3,121.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_118_",
    gradientUnits: "userSpaceOnUse",
    x1: 242.6791,
    y1: 345.6438,
    x2: 603.1899,
    y2: 345.6438
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon115 || (_polygon115 = /*#__PURE__*/React.createElement("polygon", {
    className: "st114",
    points: "603.2,564.3 599.2,567.5 242.7,127 246.6,123.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_119_",
    gradientUnits: "userSpaceOnUse",
    x1: 240.0507,
    y1: 347.7718,
    x2: 600.5607,
    y2: 347.7718
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon116 || (_polygon116 = /*#__PURE__*/React.createElement("polygon", {
    className: "st115",
    points: "600.6,566.4 596.6,569.6 240.1,129.1 244,125.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_120_",
    gradientUnits: "userSpaceOnUse",
    x1: 237.4215,
    y1: 349.8989,
    x2: 597.9324,
    y2: 349.8989
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon117 || (_polygon117 = /*#__PURE__*/React.createElement("polygon", {
    className: "st116",
    points: "597.9,568.6 594,571.7 237.4,131.2 241.4,128.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_121_",
    gradientUnits: "userSpaceOnUse",
    x1: 234.7906,
    y1: 352.0294,
    x2: 595.304,
    y2: 352.0294
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon118 || (_polygon118 = /*#__PURE__*/React.createElement("polygon", {
    className: "st117",
    points: "595.3,570.7 591.4,573.9 234.8,133.4 238.7,130.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_122_",
    gradientUnits: "userSpaceOnUse",
    x1: 232.1622,
    y1: 354.1565,
    x2: 592.6748,
    y2: 354.1565
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon119 || (_polygon119 = /*#__PURE__*/React.createElement("polygon", {
    className: "st118",
    points: "592.7,572.8 588.7,576 232.2,135.5 236.1,132.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_123_",
    gradientUnits: "userSpaceOnUse",
    x1: 229.533,
    y1: 356.2845,
    x2: 590.0438,
    y2: 356.2845
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon120 || (_polygon120 = /*#__PURE__*/React.createElement("polygon", {
    className: "st119",
    points: "590,574.9 586.1,578.1 229.5,137.6 233.5,134.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_124_",
    gradientUnits: "userSpaceOnUse",
    x1: 226.9046,
    y1: 358.4124,
    x2: 587.4147,
    y2: 358.4124
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon121 || (_polygon121 = /*#__PURE__*/React.createElement("polygon", {
    className: "st120",
    points: "587.4,577.1 583.5,580.3 226.9,139.8 230.8,136.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_125_",
    gradientUnits: "userSpaceOnUse",
    x1: 224.2754,
    y1: 360.5421,
    x2: 584.7863,
    y2: 360.5421
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon122 || (_polygon122 = /*#__PURE__*/React.createElement("polygon", {
    className: "st121",
    points: "584.8,579.2 580.8,582.4 224.3,141.9 228.2,138.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_126_",
    gradientUnits: "userSpaceOnUse",
    x1: 221.6471,
    y1: 362.67,
    x2: 582.1579,
    y2: 362.67
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon123 || (_polygon123 = /*#__PURE__*/React.createElement("polygon", {
    className: "st122",
    points: "582.2,581.3 578.2,584.5 221.6,144 225.6,140.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_127_",
    gradientUnits: "userSpaceOnUse",
    x1: 219.0178,
    y1: 364.7976,
    x2: 579.5287,
    y2: 364.7976
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon124 || (_polygon124 = /*#__PURE__*/React.createElement("polygon", {
    className: "st123",
    points: "579.5,583.4 575.6,586.6 219,146.1 223,143  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_128_",
    gradientUnits: "userSpaceOnUse",
    x1: 216.387,
    y1: 366.9252,
    x2: 576.9003,
    y2: 366.9252
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon125 || (_polygon125 = /*#__PURE__*/React.createElement("polygon", {
    className: "st124",
    points: "576.9,585.6 573,588.8 216.4,148.3 220.3,145.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_129_",
    gradientUnits: "userSpaceOnUse",
    x1: 213.7585,
    y1: 369.0531,
    x2: 574.2686,
    y2: 369.0531
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon126 || (_polygon126 = /*#__PURE__*/React.createElement("polygon", {
    className: "st125",
    points: "574.3,587.7 570.3,590.9 213.8,150.4 217.7,147.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_130_",
    gradientUnits: "userSpaceOnUse",
    x1: 211.1293,
    y1: 371.1828,
    x2: 571.6402,
    y2: 371.1828
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon127 || (_polygon127 = /*#__PURE__*/React.createElement("polygon", {
    className: "st126",
    points: "571.6,589.8 567.7,593 211.1,152.5 215.1,149.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_131_",
    gradientUnits: "userSpaceOnUse",
    x1: 208.501,
    y1: 373.3108,
    x2: 569.0118,
    y2: 373.3108
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon128 || (_polygon128 = /*#__PURE__*/React.createElement("polygon", {
    className: "st127",
    points: "569,592 565.1,595.2 208.5,154.7 212.4,151.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_132_",
    gradientUnits: "userSpaceOnUse",
    x1: 205.8726,
    y1: 375.4387,
    x2: 566.3827,
    y2: 375.4387
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon129 || (_polygon129 = /*#__PURE__*/React.createElement("polygon", {
    className: "st128",
    points: "566.4,594.1 562.4,597.3 205.9,156.8 209.8,153.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_133_",
    gradientUnits: "userSpaceOnUse",
    x1: 203.2434,
    y1: 377.5659,
    x2: 563.7543,
    y2: 377.5659
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon130 || (_polygon130 = /*#__PURE__*/React.createElement("polygon", {
    className: "st129",
    points: "563.8,596.2 559.8,599.4 203.2,158.9 207.2,155.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_134_",
    gradientUnits: "userSpaceOnUse",
    x1: 200.6125,
    y1: 379.6951,
    x2: 561.125,
    y2: 379.6951
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon131 || (_polygon131 = /*#__PURE__*/React.createElement("polygon", {
    className: "st130",
    points: "561.1,598.3 557.2,601.5 200.6,161 204.6,157.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_135_",
    gradientUnits: "userSpaceOnUse",
    x1: 197.9832,
    y1: 381.8234,
    x2: 558.4966,
    y2: 381.8234
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon132 || (_polygon132 = /*#__PURE__*/React.createElement("polygon", {
    className: "st131",
    points: "558.5,600.5 554.6,603.7 198,163.2 201.9,160  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_136_",
    gradientUnits: "userSpaceOnUse",
    x1: 195.3549,
    y1: 383.9514,
    x2: 555.8657,
    y2: 383.9514
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon133 || (_polygon133 = /*#__PURE__*/React.createElement("polygon", {
    className: "st132",
    points: "555.9,602.6 551.9,605.8 195.4,165.3 199.3,162.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_137_",
    gradientUnits: "userSpaceOnUse",
    x1: 192.7265,
    y1: 386.0794,
    x2: 553.2365,
    y2: 386.0794
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon134 || (_polygon134 = /*#__PURE__*/React.createElement("polygon", {
    className: "st133",
    points: "553.2,604.7 549.3,607.9 192.7,167.4 196.7,164.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_138_",
    gradientUnits: "userSpaceOnUse",
    x1: 190.0973,
    y1: 388.2065,
    x2: 550.6082,
    y2: 388.2065
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon135 || (_polygon135 = /*#__PURE__*/React.createElement("polygon", {
    className: "st134",
    points: "550.6,606.9 546.7,610 190.1,169.6 194,166.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_139_",
    gradientUnits: "userSpaceOnUse",
    x1: 187.4689,
    y1: 390.337,
    x2: 547.9789,
    y2: 390.337
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon136 || (_polygon136 = /*#__PURE__*/React.createElement("polygon", {
    className: "st135",
    points: "548,609 544,612.2 187.5,171.7 191.4,168.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_140_",
    gradientUnits: "userSpaceOnUse",
    x1: 184.8397,
    y1: 392.4646,
    x2: 545.3506,
    y2: 392.4646
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon137 || (_polygon137 = /*#__PURE__*/React.createElement("polygon", {
    className: "st136",
    points: "545.4,611.1 541.4,614.3 184.8,173.8 188.8,170.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_141_",
    gradientUnits: "userSpaceOnUse",
    x1: 182.2088,
    y1: 394.5921,
    x2: 542.7214,
    y2: 394.5921
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon138 || (_polygon138 = /*#__PURE__*/React.createElement("polygon", {
    className: "st137",
    points: "542.7,613.2 538.8,616.4 182.2,175.9 186.2,172.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_142_",
    gradientUnits: "userSpaceOnUse",
    x1: 179.5804,
    y1: 396.7201,
    x2: 540.0905,
    y2: 396.7201
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon139 || (_polygon139 = /*#__PURE__*/React.createElement("polygon", {
    className: "st138",
    points: "540.1,615.4 536.1,618.6 179.6,178.1 183.5,174.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_143_",
    gradientUnits: "userSpaceOnUse",
    x1: 176.9512,
    y1: 398.8476,
    x2: 537.4621,
    y2: 398.8476
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon140 || (_polygon140 = /*#__PURE__*/React.createElement("polygon", {
    className: "st139",
    points: "537.5,617.5 533.5,620.7 177,180.2 180.9,177  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_144_",
    gradientUnits: "userSpaceOnUse",
    x1: 174.3229,
    y1: 400.9777,
    x2: 534.8329,
    y2: 400.9777
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon141 || (_polygon141 = /*#__PURE__*/React.createElement("polygon", {
    className: "st140",
    points: "534.8,619.6 530.9,622.8 174.3,182.3 178.3,179.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_145_",
    gradientUnits: "userSpaceOnUse",
    x1: 171.6936,
    y1: 403.1057,
    x2: 532.2045,
    y2: 403.1057
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon142 || (_polygon142 = /*#__PURE__*/React.createElement("polygon", {
    className: "st141",
    points: "532.2,621.8 528.3,624.9 171.7,184.5 175.6,181.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_146_",
    gradientUnits: "userSpaceOnUse",
    x1: 169.0653,
    y1: 405.2328,
    x2: 529.5762,
    y2: 405.2328
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon143 || (_polygon143 = /*#__PURE__*/React.createElement("polygon", {
    className: "st142",
    points: "529.6,623.9 525.6,627.1 169.1,186.6 173,183.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_147_",
    gradientUnits: "userSpaceOnUse",
    x1: 166.4344,
    y1: 407.3608,
    x2: 526.9469,
    y2: 407.3608
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon144 || (_polygon144 = /*#__PURE__*/React.createElement("polygon", {
    className: "st143",
    points: "526.9,626 523,629.2 166.4,188.7 170.4,185.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_148_",
    gradientUnits: "userSpaceOnUse",
    x1: 163.8051,
    y1: 409.4904,
    x2: 524.3186,
    y2: 409.4904
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon145 || (_polygon145 = /*#__PURE__*/React.createElement("polygon", {
    className: "st144",
    points: "524.3,628.1 520.4,631.3 163.8,190.8 167.8,187.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_149_",
    gradientUnits: "userSpaceOnUse",
    x1: 161.1768,
    y1: 411.6184,
    x2: 521.6868,
    y2: 411.6184
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon146 || (_polygon146 = /*#__PURE__*/React.createElement("polygon", {
    className: "st145",
    points: "521.7,630.3 517.7,633.5 161.2,193 165.1,189.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_150_",
    gradientUnits: "userSpaceOnUse",
    x1: 158.5476,
    y1: 413.7464,
    x2: 519.0585,
    y2: 413.7464
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon147 || (_polygon147 = /*#__PURE__*/React.createElement("polygon", {
    className: "st146",
    points: "519.1,632.4 515.1,635.6 158.5,195.1 162.5,191.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_151_",
    gradientUnits: "userSpaceOnUse",
    x1: 155.9192,
    y1: 415.8734,
    x2: 516.4301,
    y2: 415.8734
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon148 || (_polygon148 = /*#__PURE__*/React.createElement("polygon", {
    className: "st147",
    points: "516.4,634.5 512.5,637.7 155.9,197.2 159.9,194  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_152_",
    gradientUnits: "userSpaceOnUse",
    x1: 153.2909,
    y1: 418.0015,
    x2: 513.8008,
    y2: 418.0015
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon149 || (_polygon149 = /*#__PURE__*/React.createElement("polygon", {
    className: "st148",
    points: "513.8,636.7 509.9,639.8 153.3,199.4 157.2,196.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_153_",
    gradientUnits: "userSpaceOnUse",
    x1: 150.6616,
    y1: 420.1316,
    x2: 511.1725,
    y2: 420.1316
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon150 || (_polygon150 = /*#__PURE__*/React.createElement("polygon", {
    className: "st149",
    points: "511.2,638.8 507.2,642 150.7,201.5 154.6,198.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_154_",
    gradientUnits: "userSpaceOnUse",
    x1: 148.0308,
    y1: 422.2591,
    x2: 508.5433,
    y2: 422.2591
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon151 || (_polygon151 = /*#__PURE__*/React.createElement("polygon", {
    className: "st150",
    points: "508.5,640.9 504.6,644.1 148,203.6 152,200.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_155_",
    gradientUnits: "userSpaceOnUse",
    x1: 145.4015,
    y1: 424.387,
    x2: 505.9124,
    y2: 424.387
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon152 || (_polygon152 = /*#__PURE__*/React.createElement("polygon", {
    className: "st151",
    points: "505.9,643 502,646.2 145.4,205.7 149.3,202.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_156_",
    gradientUnits: "userSpaceOnUse",
    x1: 142.7731,
    y1: 426.5146,
    x2: 503.284,
    y2: 426.5146
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon153 || (_polygon153 = /*#__PURE__*/React.createElement("polygon", {
    className: "st152",
    points: "503.3,645.2 499.3,648.4 142.8,207.9 146.7,204.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_157_",
    gradientUnits: "userSpaceOnUse",
    x1: 140.1448,
    y1: 428.6422,
    x2: 500.6548,
    y2: 428.6422
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon154 || (_polygon154 = /*#__PURE__*/React.createElement("polygon", {
    className: "st153",
    points: "500.7,647.3 496.7,650.5 140.1,210 144.1,206.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_158_",
    gradientUnits: "userSpaceOnUse",
    x1: 137.5155,
    y1: 430.7727,
    x2: 498.0265,
    y2: 430.7727
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon155 || (_polygon155 = /*#__PURE__*/React.createElement("polygon", {
    className: "st154",
    points: "498,649.4 494.1,652.6 137.5,212.1 141.5,208.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_159_",
    gradientUnits: "userSpaceOnUse",
    x1: 134.8872,
    y1: 432.8998,
    x2: 495.3972,
    y2: 432.8998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon156 || (_polygon156 = /*#__PURE__*/React.createElement("polygon", {
    className: "st155",
    points: "495.4,651.5 491.5,654.7 134.9,214.3 138.8,211.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_160_",
    gradientUnits: "userSpaceOnUse",
    x1: 132.2554,
    y1: 435.0277,
    x2: 492.7688,
    y2: 435.0277
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon157 || (_polygon157 = /*#__PURE__*/React.createElement("polygon", {
    className: "st156",
    points: "492.8,653.7 488.8,656.9 132.3,216.4 136.2,213.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_161_",
    gradientUnits: "userSpaceOnUse",
    x1: 129.627,
    y1: 437.1557,
    x2: 490.1396,
    y2: 437.1557
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon158 || (_polygon158 = /*#__PURE__*/React.createElement("polygon", {
    className: "st157",
    points: "490.1,655.8 486.2,659 129.6,218.5 133.6,215.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_162_",
    gradientUnits: "userSpaceOnUse",
    x1: 126.9987,
    y1: 439.2854,
    x2: 487.5087,
    y2: 439.2854
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon159 || (_polygon159 = /*#__PURE__*/React.createElement("polygon", {
    className: "st158",
    points: "487.5,657.9 483.6,661.1 127,220.6 130.9,217.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_163_",
    gradientUnits: "userSpaceOnUse",
    x1: 124.3695,
    y1: 441.4134,
    x2: 484.8803,
    y2: 441.4134
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon160 || (_polygon160 = /*#__PURE__*/React.createElement("polygon", {
    className: "st159",
    points: "484.9,660.1 480.9,663.3 124.4,222.8 128.3,219.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_164_",
    gradientUnits: "userSpaceOnUse",
    x1: 121.7411,
    y1: 443.5404,
    x2: 482.2511,
    y2: 443.5404
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon161 || (_polygon161 = /*#__PURE__*/React.createElement("polygon", {
    className: "st160",
    points: "482.3,662.2 478.3,665.4 121.7,224.9 125.7,221.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_165_",
    gradientUnits: "userSpaceOnUse",
    x1: 119.1119,
    y1: 445.6684,
    x2: 479.6227,
    y2: 445.6684
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon162 || (_polygon162 = /*#__PURE__*/React.createElement("polygon", {
    className: "st161",
    points: "479.6,664.3 475.7,667.5 119.1,227 123.1,223.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_166_",
    gradientUnits: "userSpaceOnUse",
    x1: 116.4835,
    y1: 447.7964,
    x2: 476.9944,
    y2: 447.7964
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon163 || (_polygon163 = /*#__PURE__*/React.createElement("polygon", {
    className: "st162",
    points: "477,666.4 473.1,669.6 116.5,229.1 120.4,226  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_167_",
    gradientUnits: "userSpaceOnUse",
    x1: 113.8526,
    y1: 449.9261,
    x2: 474.3652,
    y2: 449.9261
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon164 || (_polygon164 = /*#__PURE__*/React.createElement("polygon", {
    className: "st163",
    points: "474.4,668.6 470.4,671.8 113.9,231.3 117.8,228.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_168_",
    gradientUnits: "userSpaceOnUse",
    x1: 112.5427,
    y1: 451.5203,
    x2: 471.7343,
    y2: 451.5203
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5B06"
    }
  })), _polygon165 || (_polygon165 = /*#__PURE__*/React.createElement("polygon", {
    className: "st164",
    points: "471.7,670.7 469.1,672.8 112.5,232.3 115.2,230.2  "
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st165",
    d: "M0,732.5l16.7-23.4c10.2,10.6,26,19.5,45.9,19.5c16.9,0,25.1-7.8,25.1-16c0-25.6-83.2-8-83.2-62.4 c0-24.1,20.8-44,54.8-44c23,0,42,6.9,56.4,20.2l-17.1,22.5C86.9,638,71.3,633,56.6,633c-13.2,0-20.6,5.9-20.6,14.5 c0,23,83,7.6,83,61.6c0,26.4-18.9,46.4-57.9,46.4C33.4,755.5,13.4,746.2,0,732.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st165",
    d: "M139.8,752.9V608.3h67.6c31.4,0,48.5,21.2,48.5,46.6c0,25.1-17.3,46.6-48.5,46.6h-36.8v51.4H139.8z  M224.5,654.9c0-12.1-9.1-19.5-21.2-19.5h-32.7v39h32.7C215.4,674.4,224.5,666.8,224.5,654.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st165",
    d: "M275,752.9V608.3h30.8v144.6H275z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st165",
    d: "M434.1,752.9l-68.9-94.3v94.3h-30.8V608.3h31.6l67,90.8v-90.8h30.8v144.6H434.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st165",
    d: "M592.1,752.9l-8.9-24.5h-62l-9.1,24.5H477l55.9-144.6h38.6l55.7,144.6H592.1z M552.2,639.1l-22.5,62.2h45.1 L552.2,639.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st165",
    d: "M640.7,752.9V608.3h76.1c27.5,0,41.6,17.6,41.6,36.8c0,18.2-11.3,30.3-24.9,33.2 c15.4,2.4,27.7,17.3,27.7,35.5c0,21.7-14.5,39-42,39H640.7z M726.9,650.6c0-9.1-6.5-15.8-16.9-15.8h-38.6v31.4H710 C720.4,666.2,726.9,659.7,726.9,650.6z M729.7,709.5c0-9.1-6.5-16.9-18.6-16.9h-39.7v33.6h39.7 C722.8,726.2,729.7,719.9,729.7,709.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st165",
    d: "M784.4,752.9V608.3h30.8v117.5h61.1v27.1H784.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st165",
    d: "M897.7,752.9V608.3H1000v27.1h-71.5V666h70v27.1h-70v32.7h71.5v27.1H897.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinableWhiteLogo);
export default __webpack_public_path__ + "static/media/spinable-white-logo.83e5653ebb57f2ebd3dcd9f9b2c91461.svg";
export { ForwardRef as ReactComponent };